var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoListOv3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 302,
    viewBox: "0 0 302 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_68_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.242 161.922C236.241 155.93 249.526 141.093 252.638 122.053C257.177 94.2801 238.342 68.083 210.564 63.5435C191.529 60.4326 173.233 68.3031 162.142 82.51C156.151 65.5114 141.312 52.2261 122.277 49.1153C94.4988 44.5758 68.3048 63.4142 63.7661 91.1874C60.6546 110.227 68.5254 128.522 82.7327 139.613C65.7345 145.6 52.449 160.438 49.3376 179.477C44.7988 207.25 63.633 233.448 91.411 237.987C110.446 241.098 128.742 233.227 139.833 219.025C145.825 236.019 160.663 249.304 179.699 252.415C207.477 256.955 233.671 238.116 238.209 210.343C241.321 191.304 233.45 173.008 219.242 161.922ZM147.714 170.796C144.471 161.6 138.64 153.491 130.95 147.493C140.15 144.25 148.259 138.42 154.261 130.735C157.504 139.931 163.335 148.039 171.025 154.042C161.825 157.28 153.716 163.111 147.714 170.796Z",
    fill: "#AECC1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.946 55.0873C244.395 60.3901 266.396 90.9919 261.094 123.435C258.217 141.037 247.895 155.554 233.891 164.313C244.379 177.074 249.542 194.123 246.665 211.725C241.363 244.168 210.765 266.174 178.317 260.871C160.717 257.995 146.199 247.672 137.439 233.669C124.677 244.155 107.629 249.319 90.0289 246.443C57.5804 241.14 35.5795 210.538 40.8814 178.095C43.7579 160.494 54.0796 145.976 68.0842 137.218C57.5969 124.456 52.4334 107.407 55.3099 89.8054C60.6118 57.3623 91.21 35.3564 123.658 40.6591C141.258 43.5353 155.776 53.858 164.536 67.8629C177.298 57.375 194.347 52.2111 211.946 55.0873ZM151.868 145.38C149.878 147.015 147.785 148.519 145.601 149.885C147.236 151.874 148.742 153.967 150.108 156.15C152.097 154.515 154.191 153.01 156.374 151.645C154.739 149.656 153.233 147.563 151.868 145.38Z",
    stroke: "white",
    strokeWidth: 17.1371
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_68_16",
    x: 31.523,
    y: 31.3008,
    width: 245.931,
    height: 245.931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.00161,
    dy: 7.00161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_16",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoListOv3);
export default __webpack_public_path__ + "static/media/info-list-ov-3.4bd6f70bb88177c48f8f3cd30448f444.svg";
export { ForwardRef as ReactComponent };